import { createRouter, createWebHistory } from 'vue-router'
import index from '../views/index.vue'


//
const routes = [
  {
    path: '/Contact/:id',
    name: 'carContact',
    component: () => import('../views/contact.vue'),
  },
  {
    path: '/car/:id',
    name: 'carVue',
    component: () => import('../views/carVue.vue'),
  },
  {
    path: '/cars',
    name: 'cars',
    component: () => import('../views/allCars.vue')
  },
  {
    path: "/",
    name : "index",
    component : index
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/contact.vue')
  },
  {
    path: '/findus',
    name: 'FindUs',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/location.vue')
  },
  {
    path: '/album/:carId/:imageIndex',
    name: 'ImageAlbum',
    component: () => import('@/views/ImageAlbum.vue')
  },

  {
    path: '/Sell-your-Vehicle',
    name: 'Sell-your-Vehicle',
    component: () => import('../views/sell-your-vehicle.vue')
  },
  {
    path: '/WarrantyInformation',
    name: 'WarrantyInformation',
    component: () => import( '../views/warranty.vue')
  },
  {
   path: '/AddOns',
    name: 'Add-ons',
    component: () => import( '../views/addOn.vue')
  },
  {
   path: '/DepositConditions',
    name: 'Deposits',
    component: () => import( '../views/Deposit.vue')
  }
]
const router = createRouter({
  history: createWebHistory('/'),
  routes
})
router.beforeEach((to, from)=> {
  document.title = to.meta?.title ?? 'AFM | Affordable Motors Billingham';
})
export default router